module.exports = __webpack_public_path__ + "static/media/test4.9e7822d9.jpg";